import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetResearchProposalInformation = createAsyncThunk(
  "ResearchProposalInformation/GetResearchProposalInformation",
  async (applicationInformationId, { rejectWithValue }) => {
    console.log(applicationInformationId,"fffffff");
    
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ResearchProposalInformation/GetResearchProposalInformation",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "ff");

      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateResearchProposalInformation = createAsyncThunk(
  "ResearchProposalInformation/UpdateResearchProposalInformation",
  async (updateInfo, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ResearchProposalInformation/UpdateResearchProposalInformation",
        {
          researchProposalInformationId:
            updateInfo.researchProposalInformationId,
          fieldId: updateInfo.fieldId,
          specializedResearchProjectScope:
            updateInfo.specializedResearchProjectScope,
          keywordsAboutTheResearchProject:
            updateInfo.keywordsAboutTheResearchProject,
          researchProjectTitleInArabic: updateInfo.researchProjectTitleInArabic,
          researchProjectTitleInEnglish:
            updateInfo.researchProjectTitleInEnglish,
          researchProjectSummaryInArabic:
            updateInfo.researchProjectSummaryInArabic,
          researchProjectSummaryInEnglish:
            updateInfo.researchProjectSummaryInEnglish,
          literatureReview: updateInfo.literatureReview,
          methodology: updateInfo.methodology,
          clarifyThePracticalAspectAndTheExpectedImpact:
            updateInfo.clarifyThePracticalAspectAndTheExpectedImpact,
          targetGroup: updateInfo.targetGroup,
          bibliography: updateInfo.bibliography,
          applicationInformationId: updateInfo.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "qqqq");

      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateResearchProposalInformation = createAsyncThunk(
  "ResearchProposalInformation/ValidateResearchProposalInformation",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ResearchProposalInformation/ValidateResearchProposalInformation",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ResearchProposalInformation = createSlice({
  name: "ResearchProposalInformation",
  initialState: {
    ResearchProposalInformation: {},
    loadingGetResearchProposalInformation: false,
    errorGetResearchProposalInformation: null,

    ResearchProposalInformationValidate: [],
    loadingResearchProposalInformationValidate: false,
    errorResearchProposalInformationValidate: null,

    UpdateResearchProposalInformation: {},
    loadingUpdateResearchProposalInformation: false,
    errorUpdateResearchProposalInformation: null,
  },
  reducers: {
    SetResearchProposalInformation: (state, action) => {
      state.ResearchProposalInformation = action.payload;
    },
    SetResearchProposalInformationValidate: (state, action) => {
      state.ResearchProposalInformationValidate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetResearchProposalInformation.pending, (state, action) => {
        state.loadingGetResearchProposalInformation = true;
        state.ResearchProposalInformation = action.payload;
        state.errorGetResearchProposalInformation = null;
      })
      .addCase(GetResearchProposalInformation.fulfilled, (state, action) => {
        state.loadingGetResearchProposalInformation = false;
        state.ResearchProposalInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetResearchProposalInformation.rejected, (state, action) => {
        state.loadingGetResearchProposalInformation = false;
        state.errorGetResearchProposalInformation = action.payload;
      })

      .addCase(ValidateResearchProposalInformation.pending, (state, action) => {
        state.loadingResearchProposalInformationValidate = true;
        state.ResearchProposalInformationValidate = action.payload;
        state.errorResearchProposalInformationValidate = null;
      })
      .addCase(
        ValidateResearchProposalInformation.fulfilled,
        (state, action) => {
          state.loadingResearchProposalInformationValidate = false;
          state.ResearchProposalInformationValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateResearchProposalInformation.rejected,
        (state, action) => {
          state.loadingResearchProposalInformationValidate = false;
          state.errorResearchProposalInformationValidate = action.payload;
        }
      )
      ////////////////////////////////////update//////////////////////////////////
      .addCase(UpdateResearchProposalInformation.pending, (state, action) => {
        state.loadingUpdateResearchProposalInformation = true;
        state.UpdateResearchProposalInformation = action.payload;
        state.errorUpdateResearchProposalInformation = null;
      })
      .addCase(UpdateResearchProposalInformation.fulfilled, (state, action) => {
        state.loadingUpdateResearchProposalInformation = false;
        state.UpdateResearchProposalInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateResearchProposalInformation.rejected, (state, action) => {
        state.loadingUpdateResearchProposalInformation = false;
        state.errorUpdateResearchProposalInformation = action.payload;
      });
  },
});
export const { SetResearchProposalInformation,SetResearchProposalInformationValidate } = ResearchProposalInformation.actions;

export default ResearchProposalInformation.reducer;
